import { render } from "./VerifyFire.vue?vue&type=template&id=10120fa5&scoped=true"
import script from "./VerifyFire.vue?vue&type=script&lang=js"
export * from "./VerifyFire.vue?vue&type=script&lang=js"

import "./VerifyFire.vue?vue&type=style&index=0&id=10120fa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10120fa5"]])

export default __exports__